import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TAccountRegion } from '@shared/interfaces/TProject';
import { TBaseSettingsTabParams } from '../project-settings.component';

@Component({
  selector: 'app-account-regions',
  templateUrl: './account-regions.component.html',
  styleUrls: ['./account-regions.component.scss'],
})
export class AccountRegionsComponent implements OnInit {
  public newRegionData: TAccountRegion = {
    id: '',
    name: '',
    description: '',
    budgets: [],
  };
  public params: TBaseSettingsTabParams;

  constructor(
    public dialogRef: MatDialogRef<AccountRegionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TBaseSettingsTabParams
  ) {
    this.params = data;
  }

  ngOnInit(): void {}

  public getRegions(): TAccountRegion[] {
    return this.params.selectedProject?.accountRegions ?? [];
  }

  public add() {
    const newRegion = structuredClone(this.newRegionData);
    // random 4 digit value
    const val = Math.floor(1000 + Math.random() * 9000);
    newRegion.id = `1-${val.toString()}-${newRegion.name.toLowerCase().replace(/\s/g, `-`)}`;
    if (this.params.selectedProject !== undefined && this.params.selectedProject.accountRegions === undefined) {
      this.params.selectedProject.accountRegions = [newRegion];
    } else {
      this.params.selectedProject?.accountRegions.push(newRegion);
    }
  }

  private _isNameDuplicated(regions: TAccountRegion[] | undefined, name: string): boolean {
    return (regions ?? []).map((r) => r.name).includes(name);
  }

  public addAvailable(): boolean {
    return (this.newRegionData.name.trim() !== '' && (this.newRegionData.description.trim() !== '') !== this._isNameDuplicated(this.params.selectedProject?.accountRegions, this.newRegionData.name));
  }

  public remove(region: TAccountRegion): void {
    if (this.params.selectedProject !== undefined && this.params.selectedProject.accountRegions !== undefined) {
      const regionIndex: number = this.params.selectedProject.accountRegions.findIndex((r) => r.name === region.name);
      this.params.selectedProject.accountRegions.splice(regionIndex, 1);
      this.params.selectedProject.accountBricks = this.params.selectedProject.accountBricks.filter((b) => b.regionId !== region.id);
    }
  }
}
